module.exports = __webpack_public_path__ + "img/ClickForSound_39.43d87786.png";